import { FunctionComponent } from 'react';

interface ComponentProps {
    id: string;
    className: string;
    draggable: boolean;
    onDragStart?: any;
    onDragOver?: any;
}

const Component: FunctionComponent<ComponentProps> = (props) => {

    const dragStart = (e: any) => {
        const target = e.target;

        e.dataTransfer.setData('cardId', target.id);

        setTimeout(() => {
            target.style.display = 'block';
        }, 0);
    }

    const dragOver = (e: any) => {
        e.stopPropagation();
    }

    return (
        <div
            id={props.id}
            className={props.className}
            draggable={props.draggable}
            onDragStart={dragStart}
            onDragOver={dragOver}>
            {props.children}
        </div>
    );
}

export default Component;